import { render, staticRenderFns } from "./BatchBtn.vue?vue&type=template&id=20843130&scoped=true"
import script from "./BatchBtn.vue?vue&type=script&lang=js"
export * from "./BatchBtn.vue?vue&type=script&lang=js"
import style0 from "./BatchBtn.vue?vue&type=style&index=0&id=20843130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20843130",
  null
  
)

export default component.exports